<template>
<w-map-popup title="오브젝트 모음" class="object-element-window">
  <div>
    <el-row type="flex" justify="space-between" align="middle" style="padding-bottom:5px;">
      <div :class="$style['title-label']">추가모드 :</div>
      <el-radio-group v-model="attachMode" class="ordinary" style="margin-top: 0px;">
        <el-radio-button :label="MapConst.ATTACH_MODE.ADD">추가</el-radio-button>
        <el-radio-button :label="MapConst.ATTACH_MODE.REPLACE">교체</el-radio-button>
        <el-radio-button :label="MapConst.ATTACH_MODE.CONNECT" v-if="!isAutomap">연결</el-radio-button>
      </el-radio-group>
    </el-row>
    <el-row :class="$style['obj-collect-btn-wrapper']" type="flex" justify="space-around" align="middle">
      <w-map-button :pressed="selected(MapConst.ELEMENT_TYPE.MANAGED)" icon="map-objectmanaged-btn" tooltip="관리대상" @onClick="onElementTypeBtnClick(MapConst.ELEMENT_TYPE.MANAGED)"></w-map-button>
      <w-map-button :pressed="selected(MapConst.ELEMENT_TYPE.VIRTUAL)" icon="map-objectvirtual-btn" tooltip="가상객체" @onClick="onElementTypeBtnClick(MapConst.ELEMENT_TYPE.VIRTUAL)"></w-map-button>
      <w-map-button :pressed="selected(MapConst.ELEMENT_TYPE.IMAGE)" icon="map-objectimage-btn" tooltip="사용자 이미지" @onClick="onElementTypeBtnClick(MapConst.ELEMENT_TYPE.IMAGE)"></w-map-button>
      <w-map-button :pressed="selected(MapConst.ELEMENT_TYPE.SHAPE)" icon="map-objectshape-btn" tooltip="장식도구" @onClick="onElementTypeBtnClick(MapConst.ELEMENT_TYPE.SHAPE)"></w-map-button>
      <w-map-button :pressed="selected(MapConst.ELEMENT_TYPE.SUBMAP)" icon="map-objectsubmap-btn" tooltip="하위맵" @onClick="onElementTypeBtnClick(MapConst.ELEMENT_TYPE.SUBMAP)"></w-map-button>
      <w-map-button :pressed="selected(MapConst.ELEMENT_TYPE.CUSTOM)" icon="map-objectcustom-btn" tooltip="사용자 정의 위젯" @onClick="onElementTypeBtnClick(MapConst.ELEMENT_TYPE.CUSTOM)"></w-map-button>
    </el-row>
  </div>
  <div :class="$style['element-view']">
    <div :class="[$style['element-title'], $style['title-label']]">
      {{elementTitle}}
    </div>
    <keep-alive>
      <component :is="elementView" :class="$style['current-element']"></component>
    </keep-alive>
  </div>
</w-map-popup>
</template>

<script>
import { isEmpty } from 'lodash';
import MapConst from '@/constants/topologymap';

import WMapButton from '@/views/topologymap/components/MapButton';
import WMapPopup from '@/views/topologymap/components/MapPopup';
import WManagedObjectElement from '@/views/topologymap/components/element/ManagedObjectElement';
import WVirtualObjectElement from '@/views/topologymap/components/element/VirtualObjectElement';
import WCustomImageElement from '@/views/topologymap/components/element/CustomImageElement';
import WShapeElement from '@/views/topologymap/components/element/ShapeElement';
import WSubMapElement from '@/views/topologymap/components/element/SubMapElement';
import WCustomObjectElement from '@/views/topologymap/components/element/CustomObjectElement';

export default {
  name: 'WObjectElementWindow',
  components: {
    WMapButton,
    WMapPopup,
    WManagedObjectElement,
    WVirtualObjectElement,
    WCustomImageElement,
    WSubMapElement,
    WCustomObjectElement,
    WShapeElement,
  },
  data() {
    return {
      MapConst,
      /**
       * 팝업 속성
       */
      config: {
        type: MapConst.POPUP_TYPE.WINDOW,
        x: 25, // window.innerWidth - (MapInfo.getInstance(this).getPanel().$el.clientWidth + 25),
        y: 95,
        width: 330,
        height: 715,
        minWidth: 330,
        minHeight: 715,
        clickToClose: false,
        scrollable: true,
        resizable: true,
        draggable: '.popup-header',
      },
      elementType: MapConst.ELEMENT_TYPE.MANAGED, // 오브젝트 타입
      elementView: WManagedObjectElement, // 오브젝트 View
      elementTitle: '관리대상', // 오브젝트 타이틀
    };
  },
  computed: {
    /**
     * 추가 모드 변경 감지해서 스토어랑 동기화 시킨다.
     * @type {Object}
     */
    attachMode: {
      get() {
        return this.$store.getters.getAttachMode;
      },
      set(value) {
        this.$store.commit('setAttachMode', value);
      },
    },
    isAutomap() {
      return !isEmpty(this.$store.getters.getAutomapInfo);
    },
  },
  methods: {
    /**
     * 버튼 선택 상태 반환
     * @author KangBonghun(toto1323)
     * @param  {String} elementType 오브젝트 타입
     * @return {[type]}             [description]
     */
    selected(elementType) {
      if (this.elementType === elementType) {
        return true;
      }
      return false;
    },
    /**
     * 오브젝트 타입 버튼 클릭
     * @author KangBonghun(toto1323)
     * @param  {String} type 오브젝트 타입
     * @return {[type]}      [description]
     */
    onElementTypeBtnClick(type) {
      this.elementType = type;

      switch (type) {
        case MapConst.ELEMENT_TYPE.MANAGED:
          this.elementTitle = '관리대상';
          this.elementView = WManagedObjectElement;
          break;
        case MapConst.ELEMENT_TYPE.VIRTUAL:
          this.elementTitle = '가상객체';
          this.elementView = WVirtualObjectElement;
          break;
        case MapConst.ELEMENT_TYPE.IMAGE:
          this.elementTitle = '사용자 이미지';
          this.elementView = WCustomImageElement;
          break;
        case MapConst.ELEMENT_TYPE.SUBMAP:
          this.elementTitle = '하위맵';
          this.elementView = WSubMapElement;
          break;
        case MapConst.ELEMENT_TYPE.SHAPE:
          this.elementTitle = '장식도구';
          this.elementView = WShapeElement;
          break;
        case MapConst.ELEMENT_TYPE.CUSTOM:
          this.elementTitle = '사용자 위젯';
          this.elementView = WCustomObjectElement;
          break;
        default:
      }
    },
  },
};
</script>

<style module>
.obj-collect-btn-wrapper {
  background-color: #f9fafb;
  border-top: solid 1px #a4aaba;
  border-bottom: solid 1px #b5c0ca;
  padding: 10px 5px;
}

.current-element {
  border: 1px solid #c1c1c1;
  border-radius: 3px;
  padding: 5px 10px;
  height: calc(100% - 40px) !important;
  overflow-y: hidden;
}

.element-view {
  height: calc(100% - 105px);
}

.element-title {
  height: 40px;
  padding: 20px 0px 5px 0px;
}

.title-label {
  font-size: 14px;
  font-weight: 700;
}
</style>
<style lang="scss">
.object-element-window {
  .search-area {
    margin-bottom: 10px;
    display: flex;
  }
  .el-scrollbar {
    height: calc(100% - 40px);
  }
}
</style>



// WEBPACK FOOTER //
// src/views/topologymap/components/edit/ObjectElementWindow.vue